import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { LicenseSubFormComponent } from '../../types/LicenseSubFormComponent';
import { LicenseMonthlyLicenseTrialSubFormController } from '../controller/LicenseMonthlyLicenseTrialSubFormController';
import { Observable } from 'rxjs';
import { FormGroupValue } from '../../../ui/gzForm/formGroup/types/form-group-value';
import { CompanyData } from '../../../company/types/company-data';

export class LicenseMonthlyLicenseTrialSubFormWebComponent
  extends BaseWebComponentElement
  implements LicenseSubFormComponent
{
  public controller!: LicenseMonthlyLicenseTrialSubFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: LicenseMonthlyLicenseTrialSubFormController,
    });
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get value(): FormGroupValue {
    return this.controller.view.formGroup.value;
  }

  public setViewData(): void {
    // no-op
  }

  public setCompanyData(company: CompanyData): void {}
}
